import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui';
import logo from '@/assets/logo.png';

export function AboutUs(): React.JSX.Element {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-white">
            {/* Navigation */}
            <nav className="fixed top-0 w-full bg-white/80 backdrop-blur-md z-50 border-b border-gray-100">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex justify-between items-center h-24">
                        <div className="flex items-center cursor-pointer" onClick={() => navigate('/')}>
                            <img src={logo} alt="List8.app Logo" className="h-20 w-auto" />
                        </div>
                        <div className="flex items-center space-x-4">
                            <Button variant="ghost" onClick={() => navigate('/login')}>
                                Log in
                            </Button>
                            <Button onClick={() => navigate('/signup')}>
                                Start Today
                            </Button>
                        </div>
                    </div>
                </div>
            </nav>

            {/* Content */}
            <div className="pt-32 pb-20 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto">
                <h1 className="text-4xl font-bold text-gray-900 mb-8">About Us</h1>

                <div className="prose prose-lg text-gray-600">
                    <p className="mb-6">
                        At List8.app, we believe that every property deserves to look its best. We're a small team of tech enthusiasts and real estate lovers who saw a gap in the market: professional photo editing was either too expensive or too complicated.
                    </p>

                    <p className="mb-6">
                        We built List8.app to change that. Our mission is simple: to give real estate agents and homeowners the tools they need to showcase their properties without breaking the bank. We use cutting-edge AI to do the heavy lifting, so you can focus on what you do best – selling homes.
                    </p>

                    <p>
                        We're not a faceless corporation. We're real people building tools for real people. If you have a suggestion or just want to say hi, drop us a line!
                    </p>
                </div>
            </div>

            {/* Footer */}
            <footer className="bg-gray-900 text-white py-12 mt-auto">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                    <p className="text-gray-400">
                        &copy; {new Date().getFullYear()} List8.app. All rights reserved.
                    </p>
                </div>
            </footer>
        </div>
    );
}
